import React from 'react';

interface ErrorSummaryProps {
  errors: Record<string, any>;
  title: string;
  className?: string;
}

const ErrorSummary: React.FC<ErrorSummaryProps> = ({ errors, title, className }) => {
  const errorCount = Object.keys(errors).length;

  if (errorCount === 0) {
    return null;
  }

  return (
    <div className={`bg-red-50 border-l-4 border-red-500 text-red-800 p-6 rounded-lg shadow-sm ${className || ''}`}>
      <div className="flex items-center mb-3">
        <svg className="w-6 h-6 mr-3 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
          <path
            fillRule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
            clipRule="evenodd"
          />
        </svg>
        <p className="font-semibold text-lg">{title}</p>
      </div>
      <ul className="list-disc list-inside space-y-1 ml-9">
        {Object.values(errors).map((error, index) => (
          <li key={index} className="text-sm">
            {typeof error === 'string' ? error : JSON.stringify(error)}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ErrorSummary;
